import { List, ListSubheader } from "@mui/material";

function MenuGroup(props) {
    const { sx, text, children } = props;

    return (
        <List
            sx={{ width: "100%", ...sx }}
            component="nav"
            aria-labelledby="nested-list-subheader"
            subheader={
                <ListSubheader component="div" id="nested-list-subheader">
                    {text}
                </ListSubheader>
            }
        >
            {children}
        </List>
    );
}

export default MenuGroup;
